export default {
  title: 'My products',
  noProductsText: 'No contract available. If you took out a new contract or modified an existing contract, please try again in 24 to 48 hours. If the problem continues, please contact ',
  customerService: 'Customer Service.',
  contractNumberLabel: 'Contract number:',
};
